module.exports = __webpack_public_path__ + "img/dialogRed.5565834f.png";